import SLSDevolucaoSaldoClient from '@/api/Operacoes/sls-devolucao-saldo.client';

const client = new SLSDevolucaoSaldoClient();

export default {
  namespaced: true,
  state: () => ({
    isLoading: false,
    saldos: [],
    meta: {},
    filters: {},
  }),
  actions: {
    async listar({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.listar({ ...state.filters });
        commit('SET_SALDOS', res.data || []);
        commit('SET_META', res.meta || {});
      } finally {
        commit('SET_LOADING', false);
      }
    },
    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    clearFilters({ commit }) {
      commit('CLEAR_FILTERS');
    },
  },
  mutations: {
    SET_LOADING(state, v) { state.isLoading = v; },
    SET_SALDOS(state, v)  { state.saldos = v; },
    SET_META(state, v)    { state.meta = v; },
    SET_FILTERS(state, filters) {
      const next = { ...state.filters };
      Object.entries(filters || {}).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') { delete next[k]; return; }
        next[k] = v;
      });
      state.filters = next;
    },
    CLEAR_FILTERS(state) { state.filters = {}; },
  },
  getters: {
    isLoading: (s) => s.isLoading,
    saldos:    (s) => s.saldos,
    meta:      (s) => s.meta,
    filters:   (s) => s.filters,
  },
};
